/***************************************************************************

    NavBarComponent.tsx
    -------------------------
    last Update          : September 30, 2025
    by                   : quentin.savoye@cil4sys.com
    copyright            : (C) 2025 by CIL4Sys Engineering 

***************************************************************************/


import { Container, Nav, Navbar } from "react-bootstrap"
import { Link } from "gatsby-plugin-react-i18next"
import { graphql, useStaticQuery } from "gatsby"
import "bootstrap/dist/css/bootstrap.min.css"
import React from "react"

import logoSquaremilesWhite from "../../assets/images/squaremiles/logo-complet-white-text.svg"
import logoSquaremiles from "../../assets/images/squaremiles/logo-complet-black-text.svg"
import logoCil4SysWhite from "../../assets/images/cil4sys/logo-complet-white-text.svg"
import logoCil4Sys from "../../assets/images/cil4sys/logo-complet-black-text.png"
import { NavCommonComponent } from "./BaseComponent/NavCommonComponent"
import { AllStapiInterface, NavbarItemType } from "../../types/types"
import LangMenuComponent from "./BaseComponent/LangMenuComponent"
import SocialMenu from "./BaseComponent/SocialMenuComponent"
import "../../assets/css/nav.css"

interface Props {
	language: "en" | "fr"
	data: Array<NavbarItemType>
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const NavBarComponent = ({ language: aLanguage }: { language: "en" | "fr" }): JSX.Element => {
	const query = useStaticQuery<{ allStrapiNavbarItem: AllStapiInterface<NavbarItemType> }>(graphql`
		query MyQuery1 {
			allStrapiNavbarItem {
				nodes {
					title
					rank
					locale
					navBarPosition
					navBarType
					externalLink
					page {
						name
					}
					navlinks {
						text
						link
						rank
					}
				}
			}
		}
	`)

	const data = query.allStrapiNavbarItem.nodes.filter((anItem) => anItem.locale === aLanguage)

	return <NavBarComponentClass data={data} language={aLanguage} />
}

class NavBarComponentClass extends React.Component<Props> {
	constructor(aProps: Props) {
		super(aProps)
	}

	public override render(): React.ReactNode {
		return (
			<Navbar id="all-nav-bar" className="cil4sys-navbar" expand="lg">
				<Container id="nav-bar-top" fluid className="nav-bar-container">
					<Navbar.Collapse className="justify-content-end nave-bar-collapse-top nav-bar-top">
						<NavCommonComponent
							data={this.props.data.filter((aNode) => {
								return aNode.navBarPosition === "Top"
							})}
							language={this.props.language}
							variant="top"
						/>
						<Nav>
							{process.env.GATSBY_STRAPI_PROJECT == "cil4sys" && (
								<Nav.Link as={Link} to="/resources/" className={"navlink-top nav-link"}>
									Resources
								</Nav.Link>
							)}
							<Nav.Link as={Link} to="/contact-us" className={"navlink-top nav-link"}>
								Contact
							</Nav.Link>
							<SocialMenu network="linkedin" link={process.env.GATSBY_STRAPI_PROJECT == "cil4sys" ? "https://www.linkedin.com/company/11082190/" : "https://www.linkedin.com/company/squaremiles/"} />
							<SocialMenu network="x" link={process.env.GATSBY_STRAPI_PROJECT == "cil4sys" ? "https://x.com/CIL4Sys" : "https://x.com/Squaremiles_io"} />
							{process.env.GATSBY_STRAPI_PROJECT == "cil4sys" && <SocialMenu network="youtube" link="https://www.youtube.com/channel/UCvOooMH65csdapejZkFYstg" />}
						</Nav>
						<Nav>
							<LangMenuComponent />
						</Nav>
					</Navbar.Collapse>
				</Container>
				<Container fluid className="nav-bar-container">
					<Navbar.Brand as={Link} to="/" className="logo" id="nav-bar-logo-id">
						<img
							alt=""
							src={process.env.GATSBY_STRAPI_PROJECT == "cil4sys" ? logoCil4SysWhite : logoSquaremilesWhite}
							height="60"
							className=" align-top nav-bar-logo-white"
						/>
						<img
							alt=""
							src={process.env.GATSBY_STRAPI_PROJECT == "cil4sys" ? logoCil4Sys : logoSquaremiles}
							height="60"
							className=" align-top nav-bar-logo-black"
						/>
					</Navbar.Brand>
					<Navbar.Toggle
						onClick={(anEvent) => {
							const elem = document.getElementById("all-nav-bar")
							if (elem) {
								if (elem.classList.contains("navbar-toggle-show")) {
									elem.classList.remove("navbar-toggle-show")
								} else {
									elem.classList.add("navbar-toggle-show")
								}
							}
						}}
					/>
					<Navbar.Collapse className="justify-content-end">
						<NavCommonComponent
							data={this.props.data.filter((aNode) => {
								return aNode.navBarPosition === "Middle"
							})}
							language={this.props.language}
							variant="middle"
						/>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		)
	}
}

export default NavBarComponent
